import * as actions from './actions'

const catalogEntitlementToBenefitsModule = {
    namespaced: true,
    actions,
}

export default catalogEntitlementToBenefitsModule
